module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens9-55ed5b2ab294aefd5ef24289af7f5ea4.jpg";